import React, { ChangeEvent, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Container, FormControl, InputAdornment, InputLabel, Select, TextField, Typography } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { CloudUpload, Email, Person, Phone } from '@material-ui/icons';
import { ConnectedProps, connect } from 'react-redux';
import { updateUsuario, getImagesByUser, setImageProfile } from './../redux/usuarios/actions';
import { setUser } from './../redux/user/actions';
import { fetchEmpresas } from './../redux/empresas/actions';
import { deleteUsuario } from './../redux/usuarios/actions';
import { useNavigate, } from 'react-router-dom';
import { serverConfig } from './../api/apiConfig';
import Avatar from '@mui/material/Avatar';
import { Autocomplete, Box, ButtonGroup, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, FormGroup, LinearProgress, MenuItem, Switch } from '@mui/material';
import { client, AUTH_USER, getUsers, whoami, UPDATE_USER, getCompanies, getCategories, CREATE_COMPANY } from '../graphqlClient/graphql'
import { useMutation } from '@apollo/client';
import Notifications from './../components/notifications/Notifications';
import borda from './../assets/images/comum/photo_profile.png'
import { minWidth, width } from '@mui/system';
import AccountPage from './AccountPage';
import planetPulse from 'planetpulse';
import { UploadFile } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ScoutProfileSheetModal from '../components/ScoutProfileSheetModal/ScoutProfileSheetModal';
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    maxWidth: '100%!important',
    padding: '0 16px!important',
  },
  content: {

    textAlign: 'center',
  },
  form_content_container: {
    // maxHeight: 'calc(100vh - 184px)',
    overflowY: 'auto',
    marginTop: 2,
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    minHeight: 'calc(100vh - 70px)',
    gap: 16,
    [theme.breakpoints.up('lg')]: {
      flexWrap: 'nowrap',
      alignItems: 'flex-start',
    },
  },
  form_content: {
    minWidth: 320,
    maxWidth: 420,
    marginTop: 20,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: '1 1 360px',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
    backgroundColor: green[500],
    color: 'white',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));
type PropsFromRedux = ConnectedProps<typeof connector>;
const UsuarioPage: React.FC<PropsFromRedux> = ({ setImageProfile, setUser }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const allCountries = planetPulse.getAllCountries();
  const [editUsuarioData, setEditUsuarioData] = React.useState<any>({});
  const [newUsuarioPassword, setNewUsuarioPassword] = React.useState<any>('');
  const [userCompany, setUserCompany] = React.useState<any>({});
  const [userCategory, setUserCategory] = React.useState<any>({});
  const [passwordOpen, setPasswordOpen] = React.useState(false);
  const [newUsuarioConfirmPassword, setNewUsuarioConfirmPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const permissoesList = ['administrador', 'gerente', 'basico']
  const [contador, setContador] = React.useState(0);
  const [file, setFile] = React.useState<File>();
  const [image, setImage] = React.useState<any>('');
  const [fileCompany, setFileCompany] = React.useState<File>();
  const [imageCompany, setImageCompany] = React.useState<any>('');
  const [update, setUpdate] = React.useState<any>(false);
  const [openConfirmEmail, setOpenConfirmEmail] = React.useState<any>(false);
  const [usuario, setUsuario] = React.useState<any>({});
  const [companies, setCompanies] = React.useState<any>([]);
  const [categories, setCategories] = React.useState<any>([]);
  const [addCompanyModalOpen, setAddCompanyModalOpen] = React.useState(false);
  const [newCompany, setNewCompany] = React.useState<any>({});
  const [openScoutSheet, setOpenScoutSheet] = React.useState<boolean>(false);
  const [UpdateUserMutation, { data }] = useMutation(UPDATE_USER);
  const [CreateCompanyMutation, { data:createCompanyImput }] = useMutation(CREATE_COMPANY);
  /* useEffect(() => {
    console.log("imagesByUser useEffect", imagesByUser)
    const imagesList:any = [];
    let cont = 0
    imagesByUser.map((item:any, index:any)=>{
      cont = (cont < item.contador ? item.contador : cont)
      const slide = {
        key: index,
        title: 'Usuario',
        text: '',
        image:serverConfig.dev.url + 'imagens/imagem/'+item._id,
        backgroundColor: 'green',
        
      }
      imagesList.push(slide)
    })
    console.log('imagesList ==>>> ', imagesList)
    console.log('cont ==>>> ', cont)
    setContador(cont)
    if(imagesList.length){
      const image = imagesList[0].image
      setImage(image)
      setImageProfile(image)
    }
    //setSlides(imagesList)
   
  },[imagesByUser]); */

  const getCategoriesAsync = async () => {

    const result: any = await getCategories()
    console.log('resutl ===>', result)

    if (result?.length) {

      setCategories(result)
    }
    getCompaniesAsync()
  }

  const getCompaniesAsync = async () => {

    const result: any = await getCompanies()
    console.log('resutl ===>', result)

    if (result?.length) {
      setCompanies(result)

    }
  }


  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
      setImage(URL.createObjectURL(e.target.files[0]))
    }
  };
  const handleFileChangeCompany = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFileCompany(e.target.files[0]);
      setImageCompany(URL.createObjectURL(e.target.files[0]))
    }
  };
  const getUser = async () => {
    setLoading(true)
    try {
      const user: any = await whoami();
      console.log('user ==>>', user)
      if (user.category)
        setUserCategory(user.category)
      if (user.company)
        setUserCompany(user.company)
      setUsuario(user);
    }
    catch (error) {
      console.log("Erro no getUser >>>>>", error)
    }
    setLoading(false)
  }
  useEffect(() => {

    getUser();

  }, [])
  useEffect(() => {

    getCategoriesAsync();
    //setUserCompany(perm)
    setEditUsuarioData(usuario)
    if (usuario?.category) {
      setUserCategory(usuario.category)
    }
    if (usuario?.image) {
      const imagePath = serverConfig.dev.url + 'images/' + usuario.image;
      setImage(imagePath)
      setImageProfile(imagePath)
      console.log('configurou o image profile')
    }
    if (usuario && usuario.name) setUser(usuario)
  }, [usuario])


  const updateUser: any = async (updateUserInput: any) => {
    setLoading(true);

    try {
      const userToken = await UpdateUserMutation({
        variables: {
          updateUserInput: updateUserInput,
        },
        onCompleted: ({ updateUser }) => {
          console.log('user result== > ', updateUser);
          const notData = {
            type: 'success',
            message: 'User updated successfully!',
            title: 'wescout',
            timeOut: 2000,
            callback: () => { },
            priority: true,
          };
          Notifications(notData);
          getUser();
          setPasswordOpen(false);
          setNewUsuarioPassword('');
          setNewUsuarioConfirmPassword('');
          setFile(undefined);
        }
      });
    } catch (error: any) {
      console.log("Erro ao atualizar usuário", error);

      let errorMessage = error?.message || 'Error updating user profile';

      const isDuplicate =
        errorMessage.includes('E11000') ||
        errorMessage.toLowerCase().includes('duplicate key') ||
        errorMessage.toLowerCase().includes('email_1 dup key');

      if (isDuplicate) {
        errorMessage = 'This email is already in use by another account.';
      } else if (errorMessage.includes('Variable "$updateUserInput"')) {
        errorMessage = 'Failed to update profile. Please verify your data and try again.';
      }

      const notData = {
        type: 'error',
        message: errorMessage,
        title: 'wescout',
        timeOut: 3500,
        callback: () => { },
        priority: true,
      };
      Notifications(notData);
    }
    setLoading(false);
  };

  const handleUpdate = () => {
    setUpdate(true);

    if (!editUsuarioData.name || editUsuarioData.name.trim() === '') {
      Notifications({
        type: 'error',
        message: 'Please provide a valid user name',
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      });
      return;
    }

    const currentEmail = usuario?.email || editUsuarioData.email;
    if (!currentEmail || currentEmail.trim() === '') {
      Notifications({
        type: 'error',
        message: 'Please provide a valid email',
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      });
      return;
    }

    // Password validation if change password was opened and filled
    if (passwordOpen && newUsuarioPassword) {
      if (newUsuarioPassword.length < 6) {
        Notifications({
          type: 'error',
          message: 'Password must be at least 6 characters long',
          title: 'wescout',
          timeOut: 3000,
          callback: () => { },
          priority: true,
        });
        return;
      }
      if (newUsuarioPassword !== newUsuarioConfirmPassword) {
        Notifications({
          type: 'error',
          message: 'Passwords do not match',
          title: 'wescout',
          timeOut: 3000,
          callback: () => { },
          priority: true,
        });
        return;
      }
    }

    // Build clean updateUserInput conforming to GraphQL schema
    const dataToSend: any = {
      _id: usuario._id || editUsuarioData._id,
      name: editUsuarioData.name,
      phone: editUsuarioData.phone ?? '',
      country: editUsuarioData.country ?? '',
      englishLevel: editUsuarioData.englishLevel ?? '',
      employed: Boolean(editUsuarioData.employed),
      opentorelocation: Boolean(editUsuarioData.opentorelocation),
      enableScoutingPool: Boolean(editUsuarioData.enableScoutingPool),
      uePassport: Boolean(editUsuarioData.uePassport),
    };

    if (userCategory?._id) {
      dataToSend.category = userCategory._id;
    } else if (typeof editUsuarioData.category === 'string') {
      dataToSend.category = editUsuarioData.category;
    } else if (editUsuarioData.category?._id) {
      dataToSend.category = editUsuarioData.category._id;
    }

    if (userCompany?._id) {
      dataToSend.company = userCompany._id;
    } else if (typeof editUsuarioData.company === 'string') {
      dataToSend.company = editUsuarioData.company;
    } else if (editUsuarioData.company?._id) {
      dataToSend.company = editUsuarioData.company._id;
    }

    if (file) {
      dataToSend.image = file;
    }

    if (editUsuarioData.keywords) {
      dataToSend.keywords = editUsuarioData.keywords;
    }
    if (editUsuarioData.grade) {
      dataToSend.grade = editUsuarioData.grade;
    }
    if (editUsuarioData.uePassportDetail) {
      dataToSend.uePassportDetail = editUsuarioData.uePassportDetail;
    }
    if (editUsuarioData.linkedin) {
      dataToSend.linkedin = editUsuarioData.linkedin;
    }
    if (typeof editUsuarioData.confirmed === 'boolean') {
      dataToSend.confirmed = editUsuarioData.confirmed;
    }
    if (editUsuarioData.role) {
      dataToSend.role = editUsuarioData.role;
    }
    if (editUsuarioData.userType) {
      dataToSend.userType = editUsuarioData.userType;
    }
    if (Array.isArray(editUsuarioData.favorites)) {
      dataToSend.favorites = editUsuarioData.favorites;
    }

    if (passwordOpen && newUsuarioPassword) {
      dataToSend.password = newUsuarioPassword;
      dataToSend.confirmPassword = newUsuarioConfirmPassword;
    }

    console.log('datatosend ==> ', dataToSend);
    updateUser(dataToSend);
  };

  const clearNewCompany =() => {
    setNewCompany({})

  }
  const clearImage = () => {
    setImage('')
  
};

  const handleAddCompany = async () => {
    const dataToSend = {...newCompany, createdBy: usuario._id, approved:false}
    console.log('dataToSend', dataToSend)
    if(file){
      console.log(file)
      dataToSend.image = file;
      //dataToSend.contador = (contador+1);
    } 
    // dataToSend.id = dataToSend._id
    delete dataToSend.__typename
    console.log('dataToSend',dataToSend)
    if(typeof dataToSend.image == 'string') delete dataToSend.image
    try{
      
      const createCompanyInput = dataToSend
      console.log('createCompanyInput', dataToSend)
      
      const result = await CreateCompanyMutation({
        variables: {
          createCompanyInput
        },
        onCompleted: ({createCompany} ) => {
          
          console.log('company created== > ',createCompany);
          const notData = {
            type : 'success',
            message : `Company ${createCompany?.name} Created Successfully!` ,
            title : 'wescout',
            timeOut : 1500,
            callback : ()=>{},
            priority : true,
          }
          
          getCompaniesAsync()
          if(createCompany?._id){
            setUserCompany(createCompany)
          }
          
          Notifications(notData)
          
          //navigate('/login')
          //setCompany(updateUser);
        }
      });
    } catch(error:any){
      const notData = {
        type : 'error',
        message : error.message,
        title : 'wescout',
        timeOut : 2500,
        callback : ()=>{},
        priority : true,
      }
      Notifications(notData)
      console.log("Erro ao criar company", error)
  
    }
    setAddCompanyModalOpen(false);
    clearNewCompany()
  };

  const validateEmail = (email: any) => {
    return true
    // Implemente a lógica de validação do e-mail aqui
  };

  const validatePassword = (password: string | any[]) => {
    return password.length >= 6;
  };

  const validateConfirmPassword = (password: any, confirmPassword: any) => {
    return password === confirmPassword;
  };

  const handleCloseDialog = (event: Event | React.SyntheticEvent) => {

    setOpenConfirmEmail(false);
  };
  const handleChangeEmployed = (event: Event | React.SyntheticEvent) => {


    editUsuarioData.employed ? setEditUsuarioData({ ...editUsuarioData, employed: false }) : setEditUsuarioData({ ...editUsuarioData, employed: true })

  };
  const handleChangeEnableScoutingPool = (event: Event | React.SyntheticEvent) => {
    editUsuarioData.enableScoutingPool ? setEditUsuarioData({ ...editUsuarioData, enableScoutingPool: false }) : setEditUsuarioData({ ...editUsuarioData, enableScoutingPool: true })
  };
  const handleChangeUePassport = (event: Event | React.SyntheticEvent) => {
    editUsuarioData.uePassport ? setEditUsuarioData({ ...editUsuarioData, uePassport: false }) : setEditUsuarioData({ ...editUsuarioData, uePassport: true })
  };
  const handleChangeOpentorelocation = (event: Event | React.SyntheticEvent) => {


    editUsuarioData.opentorelocation ? setEditUsuarioData({ ...editUsuarioData, opentorelocation: false }) : setEditUsuarioData({ ...editUsuarioData, opentorelocation: true })

  };

  return (
    <Container maxWidth={false} className={classes.container}>
      <div style={{ width: '100%', height: '100%' }}>
        {/* <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button> */}
        <Dialog
          open={openConfirmEmail}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Enter the code that was sent to your email."}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please, send your complete CV in PDF format to receive your feedback.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={handleCloseDialog}>Not now</Button>
            <Button variant='contained' onClick={(e: any) => {
              handleCloseDialog(e)
              navigate('/account')

            }} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
        {loading ? (
          <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
        ) : null}
        {/* Adicione os componentes e funcionalidades específicas da página do usuario */}
        <div className={classes.form_content_container}>

          {/* {file&&file.name ? (<div>{file && `${file.name} - ${file.type}`}</div>):null} */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 260, flexShrink: 0, margin: '0 8px' }}>
            <div className="file-upload" style={{ margin: 0, width: '100%' }}>
              {/* <img src={uploadImg} alt="upload" /> */}
              <span className="user-info-column">
                <span style={{ height: '90px' }}>
                  <div style={{ width: '85px', height: '85px', position: 'relative', }}>
                    <img width={85} src={borda} alt="" />
                  </div>

                  <Avatar sx={{ width: 81, height: 81, top: '-82px', left: "2px" }} alt={usuario.name} src={image || usuario.avatar} />
                </span>
                <span className="user-detail">
                  <Typography variant="h5" style={{ fontWeight: 'bold', marginTop: '5px' }}>{usuario.name}</Typography>
                  <Typography variant="h6" style={{ color: '#31D841' }}>{usuario.empresa?.name || 'Scout member'}</Typography>
                </span>
              </span>
              {/* <Avatar sx={{ width: 108, height: 108 }} style={{margin:'0 auto'}} alt={usuario.name} src={image||usuario.avatar} /> */}
              <h3> {file?.name || "Choose an image"}</h3>
              <p>Maximum length 10mb</p>
              <input type="file" onChange={handleFileChange} />
            </div>

            <Button
              variant="contained"
              onClick={() => setOpenScoutSheet(true)}
              style={{
                marginTop: '12px',
                marginBottom: '12px',
                background: 'linear-gradient(45deg, #8A2BE2, #00FFFF)',
                color: '#ffffff',
                fontWeight: 600,
                fontSize: '13px',
                textTransform: 'none',
                borderRadius: '8px',
                padding: '8px 16px',
                boxShadow: '0 4px 15px rgba(0, 255, 255, 0.25)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: '100%',
                maxWidth: '240px',
                cursor: 'pointer'
              }}
            >
              <VisibilityIcon style={{ fontSize: '18px' }} />
              Professional Info Preview
            </Button>
          </div>
          <div className={classes.form_content}>



            <div className='accountData'>

              <Typography variant="h5" style={{ fontWeight: 'bold', margin: '10px' }} >
                Account Data
              </Typography>
            </div>
            <TextField
              variant="standard"
              ///style={{marginBottom:5}}
              label="User name"
              value={editUsuarioData.name}
              onChange={(e) => setEditUsuarioData({ ...editUsuarioData, name: e.target.value })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              style={{ marginBottom: 5 }}
              label="E-mail"
              disabled
              value={usuario?.email || ''}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <Email />
                  </InputAdornment>
                ),
              }}
              inputProps={{
                autoComplete: 'off',
              }}
            />

            {passwordOpen ? (
              <>
                <TextField
                  style={{ margin: 5 }}
                  label="Senha"
                  value={newUsuarioPassword}
                  onChange={(e) => {
                    setEditUsuarioData({ ...editUsuarioData, password: e.target.value })
                    setNewUsuarioPassword(e.target.value)
                  }}
                  type="password"
                  error={!validatePassword(newUsuarioPassword)}
                  helperText={!validatePassword(newUsuarioPassword) && 'Password must be at least 6 characters long'}
                />
                <TextField
                  style={{ margin: 5 }}
                  label="Confirm password"
                  value={newUsuarioConfirmPassword}
                  onChange={(e) => {
                    setEditUsuarioData({ ...editUsuarioData, confirmPassword: e.target.value })
                    setNewUsuarioConfirmPassword(e.target.value)
                  }}
                  type="password"
                  error={!validateConfirmPassword(newUsuarioPassword, newUsuarioConfirmPassword)}
                  helperText={!validateConfirmPassword(newUsuarioPassword, newUsuarioConfirmPassword) && 'Passwords do not match'}
                />
              </>

            ) : (<Button className={classes.button} onClick={() => setPasswordOpen(true)}>change password</Button>)

            }

            <Autocomplete
              getOptionLabel={(usu: any) => usu.name}
              value={{ name: editUsuarioData.country }}
              //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
              onChange={(event, newValue) => {
                console.log('selectedLocation', newValue)

                if (newValue?.name) {
                  /*  const countryInfo = planetPulse.getCountryByName(newValue?.name);
                   console.log(countryInfo); */
                  setEditUsuarioData({ ...editUsuarioData, country: newValue.name })
                  //setUserCategory(newValue)
                  //changeFilter()
                } else {
                  setEditUsuarioData({ ...editUsuarioData, country: '' })
                  //setUserCategory({})
                  //changeFilter()
                }


              }}
              disablePortal
              id="combo-box-usuario"
              options={allCountries}
              sx={{ width: '90%', margin: '5px 0' }}
              renderInput={(params: any) => <TextField {...params} label="Country where you are from" />}
            />

            <TextField
              style={{ marginBottom: 5 }}
              label="Phone"
              value={editUsuarioData.phone}
              onChange={(e) => setEditUsuarioData({ ...editUsuarioData, phone: e.target.value })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone />
                  </InputAdornment>
                ),
              }}
            /* error={!validateEmail(editUsuarioData.email)}
            helperText={!validateEmail(editUsuarioData.email) && 'E-mail inválido'} */
            />

            <Autocomplete
              getOptionLabel={(usu: any) => usu?.name||'Category that interests you'}
              value={userCategory}
              //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
              onChange={(event, newValue) => {
                console.log('selectedCategory', newValue)

                if (newValue?.name) {
                  setUserCategory(newValue)
                  //changeFilter()
                } else {
                  console.log('limpou')
                  setUserCategory({})
                  //changeFilter()
                }


              }}
              disablePortal
              id="combo-box-category"
              options={categories}
              sx={{ width: '90%', margin: '5px 0' }}
              renderInput={(params: any) => <TextField {...params} label="Category that interests you" />}
            />
            {
              usuario.role == 'scouter' || usuario.role == 'admin' ?
              <>
              {
                !usuario?.company?.name ? 
                <Box margin={2}>
                  <Typography style={{cursor:'pointer', fontSize:'12px', color:'#31D841'}} onClick={()=>{setAddCompanyModalOpen(true)}}>
                    click here to add new company 
                  </Typography>
                  <Typography style={{fontSize:'10px!important'}}>
                    if your company is not listed bellow
                  </Typography>
                </Box>
                : null
              }
              
              <Autocomplete
                  disabled={true}
                  getOptionLabel={(usu: any) => usu?.name||'your company'}
                  value={userCompany}
                  //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
                  onChange={(event, newValue) => {
                    console.log('selectedCompany', newValue)

                    if (newValue?.name) {
                      setUserCompany(newValue)
                      //changeFilter()
                    } else {
                      console.log('limpou')
                      setUserCompany({})
                      //changeFilter()
                    }


                  }}
                  disablePortal
                  id="combo-box-company"
                  options={companies}
                  sx={{ width: '90%', margin: '5px 0' }}
                  renderInput={(params: any) => <TextField {...params} label="Your company" />}
                />
              </>
                
                : null
            }

            <Typography >
              English Level
            </Typography>
            <ButtonGroup variant="outlined" aria-label="English Level">
              <Button className={editUsuarioData.englishLevel == 'B1' ? 'selected' : ''} onClick={(e) => setEditUsuarioData({ ...editUsuarioData, englishLevel: 'B1' })}>B1</Button>
              <Button className={editUsuarioData.englishLevel == 'B2' ? 'selected' : ''} onClick={(e) => setEditUsuarioData({ ...editUsuarioData, englishLevel: 'B2' })}>B2</Button>
              <Button className={editUsuarioData.englishLevel == 'C1' ? 'selected' : ''} onClick={(e) => setEditUsuarioData({ ...editUsuarioData, englishLevel: 'C1' })}>C1</Button>
              <Button className={editUsuarioData.englishLevel == 'C2' ? 'selected' : ''} onClick={(e) => setEditUsuarioData({ ...editUsuarioData, englishLevel: 'C2' })}>C2</Button>
            </ButtonGroup>

            <FormGroup>

              <FormControlLabel control={<Switch onChange={handleChangeEmployed} checked={editUsuarioData.employed} />} label="Employed" />
              <FormControlLabel control={<Switch onChange={handleChangeOpentorelocation} checked={editUsuarioData.opentorelocation} />} label="Open to relocation" />
              <FormControlLabel control={<Switch onChange={handleChangeEnableScoutingPool} checked={editUsuarioData.enableScoutingPool} />} label="Enable ScoutingPool" />
              <FormControlLabel control={<Switch onChange={handleChangeUePassport} checked={editUsuarioData.uePassport} />} label="UE passport" />
            </FormGroup>




            {/* <InputLabel htmlFor="permissao-select">select a category that interests you </InputLabel>
                <Select
                  value={userCategory}
                  onChange={(e: any) => setUserCategory(e.target.value)}
                  inputProps={{
                    name: 'permissao',
                    id: 'permissao-select',
                  }}
                >
                  {categories.map((category: any) => (
                    <MenuItem key={category} value={category}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select> */}



            <Button className={classes.button} style={{ margin: 15, }} onClick={() => { handleUpdate() }}>update</Button>





            {/* <TextField
              label="Empresa"
              value={editUsuarioData.empresa}
              onChange={(e) => setNewUsuarioEmpresa(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Business />
                  </InputAdornment>
                ),
              }}
              error={editUsuarioData.empresa == ""}

              helperText={
                editUsuarioData.empresa=="" &&
                'Empresa inválida'
              }
            /> */}
          </div>
          <div style={{ minWidth: 320, maxWidth: 450, flex: '1 1 360px' }}>
            <Typography component="div">
              <AccountPage />
            </Typography>
          </div>

        </div>


        <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button>
      </div>
      <Dialog open={addCompanyModalOpen} onClose={() => setAddCompanyModalOpen(false)}>
        <DialogTitle>Add new company</DialogTitle>
        <DialogContent className={classes.modalContent}>
          <Typography>
            Your company will appear in our "scouting pool" after approval.
          </Typography>
        <div className="file-upload-img">
                            {imageCompany ? <img src={imageCompany} alt="upload" /> : <UploadFile />}
                            {/* <Avatar sx={{ width: 108, height: 108 }} style={{margin:'0 auto'}} alt={usuario.name} src={imageCompany||usuario.avatar} /> */}
                            
                            {fileCompany? <div style={{color:'white'}}>image to upload: <span className='subtitle'>{fileCompany?.name||''}</span> . </div>:null}
                            {/* <h3> {file?.name || "Choose a pdf file"}</h3> */}
                            <p>Maximum length 10mb</p>
                            {/* <input type="file" onChange={handleFileChange} /> */}
                            {
                                !fileCompany?.name||!imageCompany ? <label htmlFor="contained-button-file">
                                <input
                                    accept="application/image"
                                    style={{ display: 'none' }}
                                    id="contained-button-file"
                                    type="image"
                                    onChange={handleFileChangeCompany}
                                />
                                <Button variant="contained" component="span">
                                    Choose a image file
                                </Button>
                            </label> : <Button onClick={()=>clearImage()} variant="contained" component="span">
                                    clear
                                </Button>
                            }
                            
                        </div>

            
        
          <TextField
            label="Company name"
            value={newCompany.name}
            onChange={(e) => setNewCompany({...newCompany , name : e.target.value})}
          />
          <TextField
            label="Company description"
            value={newCompany.description}
            onChange={(e) => setNewCompany({...newCompany , description : e.target.value})}
          />
         
          
            
            {/* <FormControl fullWidth>
              <InputLabel htmlFor="empresa-select">Selecione a Empresa</InputLabel>
              <Select
                value={newCompanyEmpresa}
                onChange={(e:any) => setNewCompanyEmpresa( e.target.value )}
                inputProps={{
                  name: 'empresa',
                  id: 'empresa-select',
                }}
              >
                {empresas.map((empresa: { _id: any; nome: any; }) => (
                  <MenuItem key={empresa._id} value={empresa._id}>
                    {empresa.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel htmlFor="permissao-select">Selecione o tipo de usuário</InputLabel>
              <Select
                value={newCompanyPermissoes}
                onChange={(e:any) => setNewCompanyPermissoes( e.target.value )}
                inputProps={{
                  name: 'permissao',
                  id: 'permissao-select',
                }}
              >
                {permissoesList.map((permissao: any) => (
                  <MenuItem key={permissao} value={permissao}>
                    {permissao}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

          
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddCompanyModalOpen(false)}>Cancelar</Button>
          <Button onClick={handleAddCompany} color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
      <ScoutProfileSheetModal
        open={openScoutSheet}
        onClose={() => setOpenScoutSheet(false)}
        scout={{ ...usuario, ...editUsuarioData }}
        image={image}
      />
    </Container>
  );
};

const mapStateToProps = (state: any) => ({

});

const mapDispatchToProps = {
  setUser,
  setImageProfile
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(UsuarioPage);


